import { observer } from 'mobx-react-lite'
import React, { useContext, useState } from 'react'
import getUnicodeFlagIcon from 'country-flag-icons/unicode'
import { ChevronDown, ChevronUp } from 'react-bootstrap-icons'
import { CampaignContext } from '../../../../../contexts/CampaignContext'
import { formatNumber } from '../../../../../utils/Helper'
import SelectionStatusIcon from '../../../../Shared/SelectionStatusIcon'

export default observer(function SelectedInfluencers() {
  const { authentications } = useContext(CampaignContext)
  const [expanded, setExpanded] = useState(false)
  return (
    <div className="mt-4 p-4 bg-rb-grey dark:bg-rb-dark-mode-background">
      <button type="button" className="flex items-center gap-2 mb-2" onClick={() => setExpanded(!expanded)}>
        <p className="font-bold text-md dark:text-white leading-none">Selected Influencers</p>
        {expanded ? <ChevronUp className="dark:text-white" /> : <ChevronDown className="dark:text-white" />}
      </button>
      {expanded && (
        <div className="grid grid-cols-3 gap-4">
          {authentications.map(authentication => (
            <div key={authentication.authentication_id} className="border-1 border-gray-200 dark:border-rb-dark-mode-lighter p-4 flex rounded-md bg-white dark:bg-rb-dark-mode">
              <img className="w-20 h-20 rounded object-cover" src={authentication.avatar} alt="" />
              <div className="ml-4 w-full">
                <div className="flex justify-between items-start w-full font-sm dark:text-white">
                  <div>
                    <a className="font-bold hover:text-rb-green dark:text-white dark:hover:text-rb-green" href={`/project_manager/authentications/${authentication.authentication_id}/influencer/overview`} target="_blank" rel="noopener noreferrer">{authentication.username}</a>
                    <span className="ml-1">{authentication.country && getUnicodeFlagIcon(authentication.country)} {authentication.country}</span>
                  </div>
                  <SelectionStatusIcon selectionStatus={authentication.selection_status} />
                </div>
                <p className="font-sm dark:text-gray-400 mt-1">Reach<span className="text-rb-green dark:text-rb-green ml-2 font-bold">{formatNumber(authentication.reach)}</span></p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
})
